import React,{useEffect,useState} from 'react'
import CourseCategory from './CourseCategory'
import CourseLevel  from './CourseLevel'
import  CourseDetails from './CourseDetails'
import  CourseModule from './CourseModule'
import API_SERVICE from 'shared/services/api-service';
import { Redirect, Route, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next'
import Parameters from 'shared/parameters';
import {
    Button,
    Col,
    Divider,
    Image,
    Row,
    Typography,
    notification,
    Space,
    Form,
    Input, Upload, Spin, Select, Skeleton, InputNumber, Switch,
} from 'antd';
import { setConstantValue } from 'typescript'
import { AuthConsumer } from 'shared/contexts/AuthContext'
import LoginForm from 'shared/view/login/LoginForm'
interface Props{
  hideHeader:any,
  location:any
}
function AddCourseForm(props:Props) {
  console.log('AddcourseForm function hitted')
  const [step, setstep] = useState(1);
  const { t } = useTranslation();
  const RouteParams: any = useParams();
  const [newCourseId, setNewCourseId] = useState(null as any);
  const [formItem, setFormItem] = useState(null as any);
  const [draftCourse, setDraftCourse] = useState(null as any);
  const [draftCatId, setDraftCatId] = useState(null as any);
  const [draftCatIdAdmin, setDraftCatIdAdmin] = useState(null as any);
  const [draftLevelId, setDraftLevelId] = useState(null as any);
  const [draftLevelIdAdmin, setDraftLevelIdAdmin] = useState(null as any);
  const [fetching, setFetching] = useState(true);
  const [courseAuthorId, setCourseAuthorId] = useState(null as any);
  const [draftId, setDraftId] = useState(null as any);
  const [draftIdAdmin, setDraftIdAdmin] = useState(null as any);
  const [formData, setFormData] = useState({
        category_id: '',
        level_id:'',
        // courseTitle:'',
        // courseTitleDe:'',
        // courseShortDesc:'',
        // courseShortDescDe:'',
        // courseBenefits:'',
        // courseBenefitsDe:'',
        // courseDescDe:'',
        // courseDesc:'',
        // courseInstructor:'',
        // courseFeatured:'',
        // coursePopular:'',
        // coursePlan:'',
        // coursePrice:'',
        // courseSalePrice:''
  })
console.log("formData",formData)
  const nextStep = () => {
    setstep(step + 1);
  };
  const prevStep = () => {
    setstep(step - 1);
  };
  const idCourse = (courseIdVal:any) => {
    setNewCourseId(courseIdVal);
  };
  
  const refreshItem = async () => {
    try {
      setFetching(true);
        const {
            data: { data },
        } = await API_SERVICE.fetchCourseByIdAdmin(RouteParams['id']);
        setFormItem({
            ...data,
            instructor_id: data.user_id,
        });
        setCourseAuthorId(data.author.id)
    } catch (e) {
        notification.error({
            message: t(API_SERVICE.handleErrors(e)),
        });
    } finally {
      setFetching(false);
    }
};

const fetchDraftData = async () => {
  console.log('fetcheddd')
  try {
    setFetching(true);
    if(Parameters.Mode !== 'CLIENT'){
      const {
        data: { data },
      } = await API_SERVICE.fetchDraftCourseAdmin();
      console.log('fetched admin draf data',data)
      if(data){
        setDraftCourse(data)
        setDraftIdAdmin(data.id)
        setDraftCatIdAdmin(data.category_id)
        setDraftLevelIdAdmin(data.level_id)
      }
    }else{
      const {
        data: { data },
      } = await API_SERVICE.fetchDraftCourseInstructor();
      console.log('fetched ins draf data',data)
      if(data){
        setDraftCourse(data)
        setDraftId(data.id)
        setDraftCatId(data.category_id)
        setDraftLevelId(data.level_id)
      }
    }
  } catch (e) {
    notification.error({
        message: t(API_SERVICE.handleErrors(e)),
    });
  } finally {
    setFetching(false);
  }
}
  const handleCatData = (catIds : any) =>{
    setFormData(prevState => ({
      ...prevState,
      ["category_id"]: catIds
    }));
  }
  const handleInputData = (input: any) => (e: { target: { value: any; }; }) => {
    const {value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [input]: value
    }));
  }
  useEffect(() => {
    if(!RouteParams['id']){
      fetchDraftData()
    }
    if (RouteParams['id']) {
        refreshItem();
    } else {
      setFetching(false);
    }
}, []);
if (fetching) {
    return <Skeleton active={true} />;
}
  switch (step) {
    case 1:
      return (
        <AuthConsumer>
            {({ user,isAuth }) => (
              !isAuth ? (
                <Route exact>
                    <Redirect to={'/login'}/>
                </Route>
            ) : (
              // <div> {console.log("obj", user) }</div>
            (user?.id == courseAuthorId) || user?.role?.id == 2 || courseAuthorId == null && (user?.role?.slug !== 'STUDENT') ?
            <><CourseCategory nextStep={nextStep} 
            draftCatVal={draftCatId != null ? draftCatId : draftCatIdAdmin != null ? draftCatIdAdmin : ""} 
            handleCatData={handleCatData} 
            values={formData} 
            catVal={formItem && formItem.category_id ? formItem.category_id : ''} /></> 
            : <><div>
                {setFetching(true)}
                <h5 className="text-center mt-5 mb-5">{t('genDict.PermissionDenied')}</h5>
                {setFetching(false)}
                </div>
              </>
            )
            )}
        </AuthConsumer>
      );
    case 2:
      return (
        <AuthConsumer>
            {({ user,isAuth }) => (
              !isAuth ? (
                  <Route exact>
                      <Redirect to={'/login'}/>
                  </Route>
              ) : (
                (user?.id == courseAuthorId) || user?.role?.id == 2 || courseAuthorId == null && (user?.role?.slug !== 'STUDENT') ?
                <CourseLevel nextStep={nextStep} 
                prevStep={prevStep} 
                handleCatData={handleCatData}
                handleFormData={handleInputData} 
                values={formData} 
                catVal={formItem &&formItem.category_id ? formItem.category_id :''} 
                levelVal={formItem &&formItem.level_id ? formItem.level_id :''}
                draftCatVal={draftCatId != null ? draftCatId : draftCatIdAdmin != null ? draftCatIdAdmin : ""}
                draftLevelVal={draftLevelId != null ? draftLevelId : draftLevelIdAdmin != null ? draftLevelIdAdmin : ""}   />
                : <><div>
                  {setFetching(true)}
                  <h5 className="text-center mt-5 mb-5">{t('genDict.PermissionDenied')}</h5>
                  {setFetching(false)}
                  </div>
                </>
              )
            )}
        </AuthConsumer>
      );
      case 3:
      return (
        <AuthConsumer>
            {({ user,isAuth }) => (
              !isAuth ? (
                  <Route exact>
                      <Redirect to={'/login'}/>
                  </Route>
              ) : (
                (user?.id == courseAuthorId) || user?.role?.id == 2 || courseAuthorId == null && (user?.role?.slug !== 'STUDENT') ?
                <CourseDetails 
                nextStep={nextStep} 
                prevStep={prevStep} 
                values={formData} 
                draftCourseId={draftId != null ? draftId : draftIdAdmin != null ? draftIdAdmin : ""}
                draftCatVal={draftCatId != null ? draftCatId : draftCatIdAdmin != null ? draftCatIdAdmin : ""}
                draftLevelVal={draftLevelId != null ? draftLevelId : draftLevelIdAdmin != null ? draftLevelIdAdmin : ""}
                idCourse={idCourse} />
                : <><div>
                  {setFetching(true)}
                  <h5 className="text-center mt-5 mb-5">{t('genDict.PermissionDenied')}</h5>
                  {setFetching(false)}
                  </div>
                </>
              )
            )}
        </AuthConsumer>
      );
    case 4:
      return (
        <AuthConsumer>
            {({ user,isAuth }) => (
              !isAuth ? (
                <Route exact>
                    <Redirect to={'/login'}/>
                </Route>
              ) : (
                (user?.id == courseAuthorId) || user?.role?.id == 2 || courseAuthorId == null && (user?.role?.slug !== 'STUDENT') ?
                <CourseModule location newCourseId={newCourseId}/>
                : <><div>
                  {setFetching(true)}
                  <h5 className="text-center mt-5 mb-5">{t('genDict.PermissionDenied')}</h5>
                  {setFetching(false)}
                  </div>
                </>
              )
            )}
        </AuthConsumer>
      );
    default:
      return (
        <div></div>
      );
  }
}
export default AddCourseForm